import React, { useState, useEffect } from "react";
import { omit } from "@bonliva-crm/common";
import { Tabs, TabsProps } from "./Tabs";
import { BackButton } from "./buttons/BackButton";
import { NextButton } from "./buttons/NextButton";

export type TabContainerProps = Omit<TabsProps, "children" | "value"> & {
  children: (renderProps: {
    tabs: JSX.Element;
    nextBtn: JSX.Element;
    prevBtn: JSX.Element;
  }) => JSX.Element;
};

export function TabContainer(props: TabContainerProps) {
  const [value, setValue] = useState(undefined);
  useEffect(() => {
    if (!Array.isArray(props.tabs) || props.tabs.length === 0) {
      throw new Error("tabs missing");
    }

    if (!value) {
      setValue(props.tabs[0].value);
    }
  });

  const goTo = (e: React.ChangeEvent<any>, val: string) => {
    setValue(val);
    props.onChange && props.onChange(e, val);
  };

  const { children, tabs } = props;

  const index = tabs.findIndex((t) => t.value === value);

  const prevBtn =
    index > 0 ? (
      <BackButton onClick={(e) => goTo(e, tabs[index - 1].value)}>
        {tabs[index - 1].label}
      </BackButton>
    ) : null;

  const nextBtn =
    index < tabs.length - 1 ? (
      <NextButton onClick={(e) => goTo(e, tabs[index + 1].value)}>
        {tabs[index + 1].label}
      </NextButton>
    ) : null;

  const content = <Tabs {...omit(props, "children")} onChange={goTo} value={value} />;

  return children({ tabs: content, prevBtn, nextBtn });
}
